import api from "./axios";

export interface SyncResult {
  message: string;
  seasonYear?: number;
  years?: number[];
  upserted: number;
  errors: string[];
  /** Stale term enrollments deleted because their CampMinder assignment is gone. */
  removed?: number;
  /** Present when current-season orphan reconciliation ran. */
  reconcile?: {
    checked: number;
    unenrolled: number;
    orphaned: number;
    alreadyOrphaned: number;
  };
}

export interface IntegrationStatus {
  configured: boolean;
  clientId: number | null;
  lastSyncedAt: string | null;
}

export interface PurgeResult {
  deleted: number;
  breakdown: {
    campers: number;
    enrollments: number;
    completions: number;
    honors: number;
    assessments: number;
    terms: number;
    cabins: number;
    cabinGroups: number;
    divisions: number;
  };
}

export interface OrgCredentials {
  campMinderApiKey?: string;
  campMinderSubscriptionKey?: string;
  campMinderSiteId?: string;
}

export const integrationsApi = {
  async sync(options?: { year?: number; allYears?: boolean; fromYear?: number }): Promise<SyncResult> {
    const params: Record<string, string | number | boolean> = {};
    if (options?.allYears) {
      params.allYears = true;
      if (options.fromYear !== undefined) params.fromYear = options.fromYear;
    } else if (options?.year !== undefined) {
      params.year = options.year;
    }
    const timeoutMs = options?.allYears ? 10 * 60 * 1000 : 2 * 60 * 1000;
    const res = await api.post<SyncResult>("/integrations/sync", {}, { params, timeout: timeoutMs });
    return res.data;
  },

  async getStatus(): Promise<IntegrationStatus> {
    const res = await api.get<IntegrationStatus>("/integrations/status");
    return res.data;
  },

  async saveCredentials(creds: OrgCredentials): Promise<void> {
    await api.patch("/admin/organization", creds);
  },

  async purgeNonCampMinder(): Promise<PurgeResult> {
    const res = await api.post<PurgeResult>("/admin/purge-non-campminder");
    return res.data;
  },
};
